import EventBusyIcon from '@mui/icons-material/EventBusy'
import { Stack, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

/**
 * OutOfOfficeIndicator component
 *
 * Displays an icon and text to indicate a user is out of office.
 * Uses consistent styling: 14px icon with small-medium text in yellow.
 */
export const OutOfOfficeIndicator = () => {
  const { t } = useTranslation('requests')

  return (
    <Stack direction="row" alignItems="center" gap={1} color="yellow.900">
      <EventBusyIcon sx={{ height: '14px', width: '14px' }} />
      <Typography variant="small-medium">{t('user-tooltip-info.out-of-office')}</Typography>
    </Stack>
  )
}
